import { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";

const Anualincome = ({ onTotalAmountChange }) => {
    const [user, setUser] = useState({});
    const [token, setToken] = useState(() => localStorage.getItem('token') || null);
    const [fetchedData, setFetchedData] = useState([]);
    const [damages, setDamages] = useState([]);
    const [fetchedPaymentData, setFetchedPaymentData] = useState([]);
    const [fetchedAllPaymentData, setFetchedAllPaymentData] = useState([]);
    const [expensesData, setExpensesData] = useState([]);
    const [expensesPayments, setExpensesPayments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalAmount, setTotalAmount] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchProfile = async () => {
            const token = localStorage.getItem("token");
            if (!token) {
                navigate("/");
                return;
            }

            try {
                const response = await axios.get("https://admin.bizstor.lk/public/api/profile", {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setUser(response.data);
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    localStorage.removeItem("token");
                    navigate("/");
                }
            }
        };

        fetchProfile();
    }, []);


    useEffect(() => {
        if (user.id) {
            fetchAllData();
        }
    }, [user.id]);

    const fetchAllData = async () => {
        setLoading(true);
        try {
            const [
                dataResponse,
                paymentResponse,
                damagesResponse,
                expensesResponse,
                expensesPaymentResponse
            ] = await Promise.all([
                axios.get('https://admin.bizstor.lk/public/api/get-data'),
                axios.get('https://admin.bizstor.lk/public/api/get-payment-data'),
                axios.get('https://admin.bizstor.lk/public/api/get-damage-data'),
                axios.get('https://admin.bizstor.lk/public/api/get-expense-data'),
                axios.get('https://admin.bizstor.lk/public/api/get-expensespayment')
            ]);

            if (user.id) {
                const userId = user.id.toString().toLowerCase();

                // Filter data
                const orders = dataResponse.data.filter(order =>
                    order.usertoken.toLowerCase() === userId && order.term === 'due on receipt'
                );
                setFetchedData(orders);

                const paymentOrders = dataResponse.data.filter(order =>
                    order.usertoken.toLowerCase() === userId && order.term !== 'due on receipt'
                );
                setFetchedPaymentData(paymentOrders);

                const payments = paymentResponse.data.filter(payment =>
                    payment.usertoken.toLowerCase() === userId
                );
                setFetchedAllPaymentData(payments);

                const damageData = damagesResponse.data.filter(damage =>
                    damage.usertoken.toLowerCase() === userId
                );
                setDamages(damageData);

                const expenses = expensesResponse.data.filter(expense =>
                    expense.usertoken.toLowerCase() === userId && expense.paymenttype === 'Paid'
                );
                setExpensesData(expenses);

                const filteredPayments = expensesPaymentResponse.data.filter(expensePayment =>
                    expensePayment.usertoken?.toLowerCase() === userId
                );
                setExpensesPayments(filteredPayments);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        let total = 0;
        fetchedData.forEach(order => {
            let orderTotal = 0;
            order.items.forEach(item => {
                const itemPrice = Number(item.price);
                const itemTax = item.tax || 0;
                const itemTotal = itemPrice + (itemPrice * (itemTax / 100));
                orderTotal += itemTotal;
            });

            const discountPercentage = order.discount || 0;
            const discountAmount = (orderTotal * discountPercentage) / 100;
            orderTotal -= discountAmount;

            total += orderTotal;
        });

        let totalpay = 0;
        fetchedPaymentData.forEach(order => {
            totalpay += Number(order.payamount) || 0;
        });

        let totalallpayment = 0;
        fetchedAllPaymentData.forEach(payment => {
            totalallpayment += Number(payment.amount) || 0;
        });

        let totalexpenses = 0;
        expensesData.forEach(expense => {
            expense.items.forEach(item => {
                totalexpenses += Number(item.amount);
            });
        });

        const damageTotalPrice = damages.reduce((total, damage) => {
            damage.items.forEach(item => {
                if (damage.type === 'money back') {
                    total += Number(item.price);
                }
            });
            return total;
        }, 0);

        const totalExpensesPayments = expensesPayments.reduce(
            (sum, payment) => sum + (Number(payment.amount) || 0),
            0
        );

        const positiveTotal = total + totalpay + totalallpayment;
        const negativeTotal = damageTotalPrice + totalexpenses + totalExpensesPayments;

        const finalTotal = positiveTotal - negativeTotal;
        setTotalAmount(finalTotal);

        if (onTotalAmountChange) {
            onTotalAmountChange(finalTotal);
        }
    }, [fetchedData, damages, onTotalAmountChange, fetchedPaymentData, fetchedAllPaymentData, expensesData, expensesPayments]);

    return null;
};

export default Anualincome;